import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=3be1b24e"
import script from "./Duty.vue?vue&type=script&lang=js"
export * from "./Duty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports